import { api } from 'src/api/axios';

export const useDeletePart = (id: number | string) => api.delete(`/api/cms/part/${id}`);
